/**
 * Guide step 5: navigation tips.
 */
import React from "react";
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { VText, VImage } from "form";

/**
 * Explains how to move through course units.
 */
const Guide5 = () => {

  const { t } = useTranslation('common');

  return <Box className="flex flex-col md:flex-row justify-center items-center w-full max-w-screen-xl mx-auto gap-10 md:py-10">
      <Box className="flex justify-center items-center md:w-6/12 w-full p-4 md:px-10 md:py-20">
        <VImage src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/guide/guide5.svg`} className="w-full max-w-sm" draggable={false} />
      </Box>
      <Box className="flex flex-col md:w-6/12 w-full">
        <VText className="text-4xl mb-5">{t("Enjoy the flexibility!")}</VText>
        <VText className="text-2xl mb-2">{t("You decide on your organization and the slots you want to book in your week.")}</VText>
        <VText className="text-2xl mb-2">{t("For example: you reserve a slot on Monday afternoon devoted to videos and resources that interest you.")}</VText>
        <VText className="text-2xl">{t("Wednesday morning is a place to practice with quizzes or practical exercises.")}</VText>
      </Box>
    </Box>;
};

export default Guide5;